<template>
  <!-- ----------------------------------------------------------------------------- -->
  <!-- DatatablesCRUDActions -->
  <!-- ----------------------------------------------------------------------------- -->
  <div>
    <v-list-item-subtitle class="text-wrap">

    </v-list-item-subtitle>
    <div class="mt-4">
      <v-data-table :headers="headers" :items="listitems" sort-by="sequence" class="border" hide-default-footer dense>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Professional</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="title">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" sm="1" md="1">
                        <v-text-field v-model="editedItem.sequence" label="No." dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="11" md="11">
                        <v-text-field v-model="editedItem.qualname" label="Name of Examination, Grade, Certificate of Qualification or Membership" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.qualbodyinstname" label="Name of Qualifying Body or Institute" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="daterecvselector" v-model="daterecvselector" :close-on-content-click="false" :return-value.sync="daterecvselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datereceived" label="Date Received" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datereceived" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="daterecvselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.daterecvselector.save(editedItem.datereceived)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="datevalidselector" v-model="datevalidselector" :close-on-content-click="false" :return-value.sync="datevalidselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datevalid" label="Date Valid" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datevalid" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="datevalidselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.datevalidselector.save(editedItem.datevalid)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-if="editedIndex >= 0" v-model="editedItem.document" label="Uploaded Document" readonly dense></v-text-field>
                        <v-file-input v-model="uploadfile" label="Attach Document" append-icon="mdi-clip" accept=".png, .jpg, .pdf, .tiff" show-size dense/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.sequence`]="{ item }">
           <small>{{ item.sequence }}</small>
        </template>
        <template v-slot:[`item.qualname`]="{ item }">
           <small>{{ item.qualname }}</small>
        </template>
        <template v-slot:[`item.qualbodyinstname`]="{ item }">
           <small>{{ item.qualbodyinstname }}</small>
        </template>
        <template v-slot:[`item.datereceived`]="{ item }">
           <small>{{ formatDate(item.datereceived) }}</small>
        </template>
        <template v-slot:[`item.datevalid`]="{ item }">
           <small>{{ formatDate(item.datevalid) }}</small>
        </template>
        <template v-slot:[`item.document`]="{ item }">
           <small v-if="documentUrl(item)">
              <a :href="documentUrl(item)" target="_blank" rel="noopener">{{ item.document }}</a>
           </small>
           <small v-else class="grey--text">-</small>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>No.</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.sequence }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Qualification</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.qualname }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Qualification Body</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.qualbodyinstname }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Received</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datereceived) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Valid</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datevalid) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Document</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.document }}</small>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="dodelete(todelete)">
                  Yes
               </v-btn>
               <v-btn color="primary" dark @click="dlgconfirm = false">
                  No
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableQualPro",

   data: () => ({
      userid: 0,
      focus: false,
      daterecvselector: false,
      datevalidselector: false,
      dialog: false,
      headers: [
         {
            text: "No.",
            align: "start",
            sortable: true,
            value: "sequence",
         },
         {
            text: "Name of Examination, Grade, Certificate of Qualification or Membership",
            sortable: false,
            value: "qualname"
         },
         { text: "Name of Qualifying Body or Institute", value: "qualbodyinstname", sortable: false },
         { text: "Date Received", value: "datereceived", sortable: false },
         { text: "Date Valid", value: "datevalid", sortable: false },
         { text: "Document", value: "document", sortable: false },
         { text: "Actions", value: "actions", sortable: false }
      ],
      listitems: [],
      submitting: false,
      deleting: false,
      dlgconfirm: false,
      confirmdelete: false,
      uploadfile: null,
      editedIndex: -1,
      editedItem: {
         id: 0,
         sequence: 0,
         qualname: "",
         qualbodyinstname: "",
         datereceived: "",
         datevalid: "",
         document: "",
      },
      todelete: {
         id: 0,
         sequence: 0,
         qualname: "",
         qualbodyinstname: "",
         datereceived: "",
         datevalid: "",
         document: "",

      },
      defaultItem: {
         id: 0,
         sequence: 0,
         qualname: "",
         qualbodyinstname: "",
         datereceived: "",
         datevalid: "",
         document: "",
      }
   }),

   computed: {
      formTitle() {
         return this.editedIndex === -1 ? "Qualification (Professional): New Item" : "Qualification (Professional): Edit Item";
      }
   },

   watch: {
      dialog(val) {
         val || this.close();
      },
   },

   mounted() {
      this.$emit('QualProMounted')
   },

   methods: {
      documentUrl(item) {
         if (!item || !item.document || !item.documentpath) {
            return null
         }

         var path = String(item.documentpath).replace(/^\/+|\/+$/g, '')
         var document = String(item.document).replace(/^\/+/g, '')
         return '/' + path + '/' + encodeURIComponent(document).replace(/%2F/g, '/')
      },

      formatDate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY')
      },

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            var targetPath = ''
            this.uploadfile = null
            if (this.userid !== 0) {
               targetPath = '/member/qualpro/list/' + this.userid // get id from property
            } else {
               targetPath = '/member/qualpro/list' // get id from current login session (server-side)
            }
            axios.get(targetPath)
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.listitems = rtn.data
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
         })
      },

      editItem(item) {
         this.editedIndex = this.listitems.indexOf(item);
         this.editedItem = Object.assign({}, item);
         this.dialog = true;
      },

      deleteItem(item) {
         this.todelete = item
         this.dlgconfirm = true
      },

      dodelete(item) {
         var targetPath = "/member/qualpro/delete"
         var data = {
            id: item.id
         }
         this.dlgconfirm = false
         this.deleting = true
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.deleting = false
                  this.initialize()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      close() {
         this.dialog = false;
         setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
         }, 300);
      },

      save() {
         var targetPath = ""
         if (this.editedIndex > -1) {
            targetPath = "/member/qualpro/update"
         } else {
            targetPath = "/member/qualpro/add"
         }
         var data = new FormData()
         if (this.editedIndex > -1) {
            data.append('id', this.editedItem.id)
         } else {
            data.append('userid', this.userid)
         }
         data.append('sequence', this.editedItem.sequence)
         data.append('qualname', this.editedItem.qualname)
         data.append('qualbodyinstname', this.editedItem.qualbodyinstname)
         data.append('datereceived', this.editedItem.datereceived)
         data.append('datevalid', this.editedItem.datevalid)
         if (this.uploadfile) {
            data.append('document', this.uploadfile)
         }

         this.submitting = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            this.submitting = false
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.close()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      }

   }
};
</script>
